const local = 'http://116.211.118.70:55013/Web_WebService.asmx'
const identy = 'TE9HSU4='
export default {
  local,
  identy
}



// WEBPACK FOOTER //
// ./src/api/global.js